export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const redireccionPorRol = role => {
    if(role == 'super-admin') return {name: 'perfil'}
    if(role == 'cajero') return {name: 'perfil'}
    if(role == 'gerente') return {name: 'perfil'}
    if(role == 'ventas') return {name: 'perfil'}
    if(role == 'usuario') return {path: 'perfil'}
    return {name: 'perfil'}
    
}
